module.exports = __webpack_public_path__ + "img/ancient_hydra_small.1d1d6e1c.png";